import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';

function ApacheEcharts({ option, style }) {

    const graficoRef = useRef(null);

    useEffect(() => {

        let chart = echarts.getInstanceByDom(graficoRef.current);

        if (!chart) {
            chart = echarts.init(graficoRef.current);
        }
    
        chart.setOption(option);
    
        window.addEventListener("resize", () => {
            chart.resize();
        });
    
        return () => {
            chart.dispose();
        };

    }, [option]);
    
    return <div ref={graficoRef} style={style} />;
}

export default ApacheEcharts